import gql from 'graphql-tag'

export const userQuery = gql`
  query UserSetting($accountId: Int!, $token: String!, $userId: Int!) {
    userSetting(accountId: $accountId, token: $token, userId: $userId) {
      id
      accountId
      userId
      setting
      token
    }
  }
`
